import React from "react";
import UserBooking from "./UserBooking";
import UserDecorator from "../../containers/UserDecorator";
import { Translate } from "react-redux-i18n";
import { sortBookings } from '../../utils/utils';
import Moment from "react-moment";

export default function UsersBookings({ bookings, deleteBooking, myGuid, deleting_booking, past_date }) {
  let day_bookings = [];
  if (bookings && bookings.length > 0) {
    day_bookings = sortBookings(bookings)
  }
  return (
    <div className="user-list-wrapper">
      <div className="user-list booking-details">
        <br />
        <strong className="black-color"><Translate value='booking.existing_bookings' /></strong>
        <br />
        {day_bookings.map((booking) => {
          if (booking.is_rental === true || booking.user_guid === "n/a") {
            return <RentalDetails booking={booking} key={booking.guid} />
          } else {
            return (
              <UserDecorator userId={booking.user_guid} key={booking.guid}>
                <UserBooking
                  past_date={past_date}
                  booking={booking}
                  deleteBooking={deleteBooking}
                  myGuid={myGuid}
                  deleting_booking={deleting_booking}
                />
              </UserDecorator>
            )
          }
        }
        )}
        <br />
      </div>
    </div>
  );
}

const RentalDetails = ({ booking }) => {
  const isRental = booking.is_rental === true;
  return (
    <div className="user-item">
      <div className="meta">

        <div className="name">
          {isRental ? <Translate value='rental.rental' /> : <Translate value='booking.subscription' />}
        </div>
        <div className="context">
          <Moment date={booking.start_time} utc={true} format="D MMMM YYYY HH:mm" />
          {" - "}
          <Moment date={booking.end_time} utc={true} format="D MMMM YYYY HH:mm" />
        </div>
      </div>
    </div>
  );
}